<div class="card-answer">
	<form [formGroup]="form">
		<ng-container formArrayName="answers">
			<ng-container
				*ngFor="let formAnswer of formAnswers.controls; let i = index; trackBy: trackByFn">
				<div [formGroupName]="i">
          <div class="box">
            <div class="wrapper-form-control">
              <label class="form-label d-block"> Respuesta </label>
              <textarea
                class="form-control"
                rows="2"
                formControlName="description"
                [ngClass]="{ 'is-invalid': hasError(i, 'answers', 'description') }"
                >
              </textarea>

              <div class="invalid" *ngIf="hasError(i, 'answers', 'description')">
                {{ getFirstErrorMessage(i, 'answers', 'description') }}
              </div>
            </div>

            <div class="wrapper-form-control">
              <div class="form-check ms-auto">
                <input class="form-check-input" type="checkbox" formControlName="isCorrect">
                <label class="form-check-label">
                  Correcta
                </label>
              </div>
            </div>
          </div>

				</div>
			</ng-container>
		</ng-container>
	</form>
</div>